import { gsap }             from "gsap";
import { ScrollTrigger }    from "gsap/ScrollTrigger";
import videoVimeo           from "./videoVimeo";


let animatedPush = {
    tlPA: [],
    init() {

        if($('body').hasClass('page-node-type-homepage') || $('body').hasClass('page-node-type-marque') || $('div').hasClass('page-product')){
            this.videoSize();
            if(window.screenSize > 755){
                setTimeout(function(){
                    animatedPush.anim();
                }, 100);

                setTimeout(function(){
                    animatedPush.titlePin();
                }, 1000);
            }
        }
    },
    anim() {
        this.videoSize();

        gsap.utils.toArray('.col-right article').forEach((section, i) => {
            let id = $(section).find('video').attr('id');

            let tlPA = gsap.timeline({
                scrollTrigger: {
                    trigger: section,
                    start: 'top 80%',
                    end: 'bottom 0%',
                    scrub: 1,
                    toggleActions : 'play none none reverse',
                    markers: false
                }
            })
            tlPA.to(section, {duration: 2, opacity: 1}, 0);
            if( id != null){
                tlPA.add( function(){ videoVimeo.videoPause(id) }, 0 );
                tlPA.add( function(){ videoVimeo.videoPlay(id) }, 0 );
            }
            tlPA.to(section, {duration: 2, opacity: 0.5}, 2);
            if( id != null){
                tlPA.add( function(){ videoVimeo.videoPlay(id) }, 2 );
                tlPA.add( function(){ videoVimeo.videoPause(id) }, 2 );
            }
            tlPA.to(section, {duration: 2, opacity: 0.5}, 4);
            this.tlPA.push(tlPA);
        });
    },

    titlePin() {
        ScrollTrigger.create({
            trigger: '.bloc-pushs-animated',
            start: 'top top',
            end: 'bottom 65%',
            startTrigger: '.col-left .title2',
            endTrigger: '.col-right',
            scrub: 1,
            pin: '.col-left .title2',
            toggleActions : 'play none none reverse',
            markers: false,
        })
    },

    videoSize(){
        var size = $('.bloc-pushs-animated article').width();
        var hauteur = (size * 1.25);

        $('.bloc-pushs-animated .videoWrapper').each(function(){
            $(this).height(hauteur + 'px');
        })

        $('.bloc-pushs-animated figure').each(function(){
            $(this).height(hauteur + 'px');
        })
    },
}

export default animatedPush;
